import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { DelimitersEnum } from '@uigy/shared/enums/delimiters.enum';
import {
  UiButtonCopyComponent,
} from '@uigy/shared/components/ui-button/button-copy/ui-button-copy.component';
import { UiCounterComponent } from '@uigy/shared/components/ui-counter/ui-counter.component';
import { UiLinkComponent } from '@uigy/shared/components/ui-link/ui-link.component';
import { LinkParams, DataChipIcons } from '@uigy/shared/components/data-chip/interface';
import {
  UiDataChipIconComponent,
} from '@uigy/shared/components/data-chip/ui-data-chip-icon/ui-data-chip-icon.component';
import { OverflowTooltipDirective } from '@uigy/shared/directives/overflow-tooltip.directive';

@Component({
  selector: 'app-data-chip',

  imports: [
    UiButtonCopyComponent,
    MatTooltip,
    UiLinkComponent,
    UiDataChipIconComponent,
    UiCounterComponent,
    OverflowTooltipDirective,
  ],
  templateUrl: './ui-data-chip.component.html',
  styleUrl: './ui-data-chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiDataChipComponent {
  public values = input<string[]>([]);
  public links = input<LinkParams[]>([]);
  public label = input<string>();
  public showCopyButton = input<boolean>(false);
  public leftIcons = input<DataChipIcons[]>();
  public rightIcon = input<DataChipIcons>();
  public separateMultipleValues = input<boolean>(false);


  public textToCopy(): string {
    const links = this.links();
    if (links && links.length > 0) {
      return links.map(l => l.path).join(DelimitersEnum.pipe);
    } else {
      return this.values()?.join(DelimitersEnum.pipe) ?? '';
    }
  }

  public linksDisplay() : string[] {
    return this.links()?.map(link => link.displayName) || [];
  }

}
